import Orders from './Orders'

export default Orders



// WEBPACK FOOTER //
// ./src/components/Orders/index.js